import React from "react";

interface MultilineTextProps {
  text?: string[] | number[];
}

const MultilineText: React.FC<MultilineTextProps> = ({ text }) => {
  return <div dangerouslySetInnerHTML={{ __html: text?.join("<br />") ?? "" }} />;
};

export default MultilineText;
